import React, {useEffect} from 'react';
import {Platform, View} from 'react-native';
import {noop} from 'lodash';

import Card from '/component/base/Card';
import Icon from '/component/base/Icon';
import Text from '/component/base/Text';
import TouchableOpacity from '/component/base/TouchableOpacity';
import {HealthJourneyTestIds} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {styles} from './ClientMWL.style';
import {generateOnInfoPress} from './ClientMWL.util';

interface ClientMWLProps {
  onShowInfoPopover?: () => void;
  mwlData: {};
  fetchMSWLHR: {};
  mswlData: {};
  clientId: '';
}

export const ClientMWL: React.FC<ClientMWLProps> = ({
  onShowInfoPopover = noop,
  mwlData = {},
  mswlData = {},
  fetchMSWLHR = {},
  clientId = '',
}: any) => {
  useEffect(() => {
    fetchMSWLHR(mwlData, clientId);
  }, []);

  const {ts, tt} = useTranslation('filterScreen.filterItem');
  const {mswlUsage} = mswlData[clientId]?.data || {};

  let displayText;
  mwlData?.data?.medicalWeightLoss === true
    ? (displayText = mswlUsage || 'Not set')
    : (displayText = mswlUsage || '--');

  const isWeb = Platform.OS === 'web';

  return (
    <Card style={styles.cardContainer}>
      <View style={{flexDirection: 'row', alignItems: 'center', flexShrink: 1}}>
        <Text
          isBold
          style={styles.titleText}
          {...testProperties(HealthJourneyTestIds.weightLossMedicationLabel)}>
          {ts(
            'title.wlm',
            isWeb
              ? 'Interested in Weight loss medication'
              : 'Interested in \nWeight loss medication',
          )}
        </Text>
        <TouchableOpacity
          onPress={generateOnInfoPress({
            onShowInfoPopover,
            tt,
          })}
          {...testProperties(null, true)}>
          <Icon
            name="info"
            style={styles.infoIcon}
            testID={HealthJourneyTestIds.weightLossMedicationInfoIcon}
          />
        </TouchableOpacity>
      </View>
      <Text
        style={[styles.label, displayText === '--' && styles.centerText]}
        {...testProperties(HealthJourneyTestIds.weightLossMedicationValue)}
        isBold={displayText !== '--'}>
        {displayText}
      </Text>
    </Card>
  );
};

export default ClientMWL;
